import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { Routes } from ".";
import { useParams } from "react-router-dom";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
interface Scheduling {
  status: string;
  qtd: string;
}

export const ChartPie = ({ data }: Routes) => {
  const { getSizesComponent, componentProperty, generateRedirectUrl } = useContext(DashboardContext);
  const [dataChart, setDataChart] = useState<{
    inRoute: string;
    noRoute: string;
  }>({ inRoute: "0", noRoute: "0" });
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  useEffect(() => {
    let c_total = 0;
    data.collects.forEach((route: Scheduling) => {
      c_total = +c_total + +route.qtd;
    });
    setTotal(c_total);
    setDataChart({
      inRoute:
        data?.collects.find((objeto: Scheduling) => objeto.status === "Em rota")
          ?.qtd || "0",
      noRoute:
        data?.collects.find(
          (objeto: Scheduling) => objeto.status === "Sem rota"
        )?.qtd || "0",
    });
  }, [data]);

  const getPositionLegend = (
    width: number,
    height: number
  ): "right" | "bottom" => {
    if (width < 250 || height / width > 1.5) {
      return "bottom";
    } else {
      return "right";
    }
  };

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "pie",
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          if (
            mode === "view" &&
            componentProperty({
              id: "chartSchedulingCollectsDocuments",
              property: "redirect",
            })
          ) {
            let index = 1;
            if (config.dataPointIndex === 0) {
              index = 1;
            } else {
              index = 0;
            }
            window.open(
              await generateRedirectUrl("chartSchedulingCollectsDocuments", {
                redirectTowerToIndex: true,
                date: true,
                dueRouteDate: 'dateA',
                route_stop_type: 'C',
                doc_with_route: index,
              }),
              "_blank"
            );
          }
        },
      },
    },
    stroke: {
      colors: undefined,
    },
    labels: ["Em Rota", "Sem Rota"],
    colors: ["#01b8aa", "#FFC125"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      position: getPositionLegend(widthChart, heightChart),
    },
  };

  const series = [parseInt(dataChart.inRoute), parseInt(dataChart.noRoute)];

  useEffect(() => {
    const sizes = getSizesComponent({
      id: "chart-scheduling-collects-documents",
    });
    if (sizes.width < 250) {
      setHeightChart(sizes.height - 30);
    } else {
      setHeightChart(sizes.height - 0.2 * sizes.height);
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100 component-height">
      <HeaderComponent
        title={`Você tem ${total} coletas agendadas para hoje`}
        clickable={componentProperty({
          id: "chartSchedulingCollectsDocuments",
          property: "redirect",
        })}
        id="chart-scheduling-collects-documents"
      />
      <div id="chart" className="component-content">
        <Chart
          type="pie"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
